<template>
	<div v-if="publication && publication.url" id="pub">
		<video id="video" :src="publication.url" controls @play="played()"></video>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	props: {
		publicationId: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			read: false,
			dateSeen: null,
			firstTimePlayed: false,
			firstTimeSeen: false,
			visibilityTime: 0,
		};
	},
	computed: {
		readed() {
			return this.page == this.pageCount;
		},
		video() {
			return document.getElementById('video');
		},
		publication() {
			return this.person?.publications.find(item => item._id === this.publicationId);
		},
		...mapGetters({
			person: 'Person/person',
		}),
	},
	watch: {
		publication() {
			this.countUp = this.publication.visibilityTime;
			this.beforeCountUp = this.publication.visibilityTime;
		},
	},
	methods: {
		played() {
			if (!this.firstTimePlayed) {
				const video = document.getElementById('video');
				const vue = this;
				video.ontimeupdate = () => {
					if ((video.duration * 70) / 100 <= video.currentTime && !vue.firstTimeSeen) {
						vue.visibilityTime = video.currentTime;
						vue.read = true;
						vue.dateSeen = Date.now();
						vue.firstTimeSeen = true;
						vue.onSubmit();
					}
				};
			}
		},
		async onSubmit() {
			await this.updatePublication({
				personId: this.person._id,
				publicationId: this.publicationId,
				visibilityTime: this.visibilityTime,
				seen: this.publication.seen || this.read,
				dateSeen: this.publication.dateSeen || this.dateSeen,
			});
		},
		...mapActions({
			updatePublication: 'Person/updatePublication',
		}),
	},
};
</script>

<style scoped>
video::-webkit-media-controls-timeline {
	display: none;
}
</style>
